import { Typography } from '@elements';
import { Box } from '@mui/material';
import React from 'react';
import num_word from '@utils/num_word';

type Props = {
  total: number;
  pageNumber: number;
  totalPages: number;
};

const OrdersTitle = ({ total, pageNumber, totalPages }: Props) => {
  const pageText =
    totalPages > 1 ? ` Страница ${pageNumber + 1} из ${totalPages}.` : '';

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        mb: '26px',
      }}
    >
      <Typography color="white" fontSize={22}>
        У вас всего {total} {num_word(total, ['заказ', 'заказа', 'заказов'])}.
        {pageText}
      </Typography>
    </Box>
  );
};

export default OrdersTitle;
